import app from './app.config.json'
import lecture from './lecture.config.json'

export declare type ConfigType = {
  app: {
    siteName: string
    siteSlogan: string
    siteDesc: string
  }
  lecture: {
    activities: string[]
  }
}

const config: ConfigType = {
  app: app,
  lecture: lecture
}

export default config
